<template>
	<div id="lecture">
		<div class="row g-3 ff-ch">
			<div class="col-12 col-xl-9">
				<div class="row mb-3 mt-n1">
					<div class="col-12">
						<div class="card h-100">
							<div class="card-header border-bottom p-4">
								<h5
									class="mb-0 lh-base mt-2 fw-bold c-main-blue fs-1"
									>{{ videoData[item - 1].name }}</h5
								>
								<p class="mt-4 mb-4 lh-base fs-0">
									<span class="">{{
										videoData[item - 1].desc
									}}</span>
								</p>
							</div>
							<div class="card-body bg-gray position-relative">
								<video
									:src="videoData[item - 1].src"
									controls
									playsinline
									ref="class_video"
									@click.prevent="play"
									:style="{
										cursor: isPlay ? 'pointer' : 'auto',
									}"
								>
									<source type="video/mp4" />
								</video>
								<div
									class="button_play"
									v-show="!isPlay"
									@click.stop.prevent="play"
								>
									<i
										data-feather="play"
										width="50"
										stroke-width="2"
									></i>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row g-3 mb-3">
					<div class="col-12">
						<div class="card h-100">
							<div class="card-header border-bottom border-3">
								<h5
									class="mb-0 lh-base fw-bold c-main-blue fs-1"
									>Please feel free to leave your comment or
									question to the video</h5
								>
							</div>
							<div class="border-bottom">
								<textarea
									class="ps-card py-3 form-control ff-ch fs-0"
									placeholder="歡迎您留言交流，或分享您居家復健指導的 Tips!"
									rows="3"
									v-model="msg"
								/>
							</div>
							<div
								class="card-body ps-card py-3 border-bottom d-flex justify-content-end align-items-end"
							>
								<div class="form-check me-3">
									<input
										type="checkbox"
										class="form-check-input"
										id="anonymous"
										v-model="isAnonymous"
									/>
									<label
										class="form-check-label fs-0"
										for="anonymous"
									>
										匿名
									</label>
								</div>
								<div
									class="btn btn-primary btn-sm w-25 fs-0 py-2 ff-ch fw-light"
									@click="postReplies"
									v-show="!isPosting"
								>
									<i
										data-feather="send"
										width="18"
										stroke-width="2"
									></i>
									送出
								</div>
								<div
									class="btn btn-light bg-500 btn-sm w-25 fs-0 py-2 ff-ch fw-light"
									v-show="isPosting"
								>
									<span
										class="spinner-border spinner-border-sm me-2 align-middle"
									></span>
									送出中...
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row g-3 mb-3">
					<div class="col-12">
						<div class="card h-100">
							<div class="card-header border-bottom">
								<i
									data-feather="message-square"
									width="25"
									stroke-width="2"
								></i>
								<h5
									class="mb-0 lh-base fw-bold c-main-blue d-inline-block ms-2 fs-1"
									>討論區</h5
								>
							</div>
							<div
								class="card-body border-bottom fs-0 lh-base"
								v-for="item in partialBoard"
								:key="item.sn"
							>
								<div class="c-main-blue mb-1 fw-medium"
									>{{ item.user }}
								</div>
								<div class="text-500 mb-3 fw-light"
									>{{ item.msg }}
								</div>
								<div
									class="c-main-blue d-inline-block fw-medium"
									>{{ item.date }}
								</div>
								<span
									class="text-btn fs-0 fw-medium"
									v-show="isTeacher"
								>
									‧回覆</span
								>
								<span
									class="text-btn fs-0 fw-medium"
									v-show="item.owner === 'Y'"
									@click="showNotification(item.sn)"
								>
									‧刪除</span
								>
								<div
									class="bg-soft-primary mt-3 col-lg-10 offset-lg-2 p-3 text-end rounded"
									v-show="item.reply_msg && item.reply_date"
								>
									<div class="c-main-blue mb-1 fw-medium"
										>講師回覆</div
									>
									<div class="text-500 mb-3 fw-light"
										>{{ item.reply_msg }}
									</div>
									<div class="c-main-blue fw-medium"
										>{{ item.reply_date }}
									</div>
								</div>
							</div>
							<div
								class="card-body border-bottom fs-0 lh-base loading"
								v-show="partial <= board.length"
								@click="loadBoard"
							>
								<p class="py-3 text-500 fw-medium"
									>Load more comments ({{ partial }} of
									{{ board.length }})</p
								>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-xl-3">
				<div class="card ecommerce-card-min-width mt-n1">
					<div class="card-header">
						<div class="row">
							<h5 class="mb-0 d-flex align-items-start py-2">
								<span class="c-blue-light fs-1">
									課程內容評分
								</span>
							</h5>
						</div>
					</div>

					<div class="card-body bg-blue-bg">
						<div class="row">
							<div class="py-4">
								<div class="lh-base fw-bold c-main-blue fs-1">
									您覺得影片內容<br
										class="d-none d-xl-block"
									/>
									是否幫助您臨床所需?
								</div>
								<div class="lh-base c-main-blue fs-0 mt-3">
									請給予評分 1-5分；<br
										class="d-none d-xl-block"
									/>
									5分表示相當滿意，1分表示不滿意
								</div>
							</div>
							<div>
								<hr />
							</div>
							<div class="py-4">
								<div class="py-2" v-for="idx in 5" :key="idx">
									<input
										type="radio"
										:id="`radio-${idx}`"
										class="me-1"
										name="rating"
										:value="idx"
										v-model="cls_rating"
									/>
									<label
										:for="`radio-${idx}`"
										class="fs-0 fw-medium"
										>{{ idx }}分</label
									>
								</div>
							</div>
						</div>
						<div class="row mt-3">
							<div>
								<div
									class="btn btn-primary w-100 fs-0 ff-ch fw-light"
									@click="class_rating_submit"
								>
									<i
										data-feather="send"
										width="18"
										stroke-width="2"
									></i>
									送出
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="modal"
			data-bs-keyboard="false"
			data-bs-backdrop="static"
			tabindex="-1"
			:aria-hidden="!beforeDelete"
			:aria-modal="beforeDelete"
			:style="{
				display: beforeDelete ? 'block' : 'none',
				opacity: beforeDelete ? 1 : 0,
			}"
		>
			<div
				class="modal-dialog modal-dialog-centered h-50 justify-content-center"
				role="dialog"
			>
				<div class="modal-content position-relative border-0">
					<div
						class="position-absolute top-0 end-0 mt-2 me-2 z-index-1"
					>
						<button
							class="btn-close btn btn-sm btn-circle d-flex flex-center transition-base"
							@click="showNotification('')"
						></button>
					</div>
					<div class="modal-body p-0">
						<div class="rounded-top-lg py-3 ps-4 pe-6 bg-light">
							<i
								data-feather="alert-circle"
								width="18"
								stroke-width="2"
							></i>
							<p
								class="mb-1 text-800 ff-ch fw-medium fs-0 d-inline-block ms-2"
								>系統提示
							</p>
						</div>
						<div class="c-main-blue ff-ch fw-bold p-4 py-5 fs-1">
							留言刪除後無法回復，確定刪除？
						</div>
						<div
							class="row gx-1 d-flex justify-content-end p-3 pe-4"
						>
							<div
								class="btn btn-secondary c-white ff-ch fw-light fs-0 py-2 px-3 col-4"
								@click="showNotification('')"
								>取消</div
							>
							<div
								class="btn btn-primary c-white ff-ch fw-light fs-0 py-2 px-3 col-4 ms-2"
								@click="deleteReplies(sn)"
								>確定刪除</div
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Api from "../../script/api";
import $ from "jquery";
export default {
	data() {
		return {
			videoData: [
				{
					name: "At home rehabilitation during pandemic",
					src: `${process.env.BASE_URL}assets/media/online-lecture-1.mp4`,
					desc:
						"「新冠病毒與脊髓性肌肉萎縮症」系列影片，其中由台大兒童醫院 翁妏謹醫師，分享當疫情期間，SMA患者居家復健的準則，如何善用家中垂手可得的素材，進行拉筋伸展、心肺功能運動、力量與身體穩定度等，實用且容易執行的居家復健。",
				},
				{
					name: "COVID-19 and Neuromuscular Diseases",
					src: `${process.env.BASE_URL}assets/media/online-lecture-2.mp4`,
					desc:
						"「新冠病毒與脊髓性肌肉萎縮症」系列影片，其中高醫大附設醫院梁文貞醫師整理、分享World Muscle Society (WMS) 對於神經肌肉疾病患者與新冠病毒感染之立場與建議、真實世界中疫情對SMA患者所帶來實際影響、國際專家提供之照護或藥物治療建議。",
				},
			],
			msg: "",
			name: "",
			isAnonymous: false,
			cls_rating: "",
			isTeacher: false,
			isPlay: false,
			partial: 10,
			isPosting: false,
			sn: "",
			beforeDelete: false,
		};
	},

	computed: {
		...mapGetters({ board: "getBoardData", token: "getToken" }),
		item() {
			return this.$route.params.index - 0;
		},
		partialBoard() {
			let data = [];
			if (this.board.length > 0) {
				data = this.board.slice(0, this.partial);
			}
			return data;
		},
	},

	methods: {
		getReplies() {
			const data = { class: this.item };
			Api.post_header(
				"api/board_list",
				{ Authorization: `Bearer ${this.token}` },
				data,
				(res) => {
					if (res.res && res.msg === "ok") {
						this.$store.dispatch("handleSetBoard", res.data);
					}
				}
			);
		},
		postReplies() {
			const data = {
				class: this.item,
				msg: this.msg,
				anonymous: this.isAnonymous ? "Y" : "N",
			};

			if (this.msg === "") {
				alert("請輸入您的回覆");
				return;
			}

			this.isPosting = true;

			Api.post_header(
				"api/board_message_do",
				{ Authorization: `Bearer ${this.token}` },
				data,
				(res) => {
					if (res.res && res.msg === "ok") {
						this.getReplies();
						this.msg = "";
						this.name = "";
						this.isAnonymous = false;
					}
					this.isPosting = false;
				}
			);
		},
		deleteReplies(val) {
			const data = {
				sn: val,
			};

			Api.post_header(
				"api/board_message_del",
				{ Authorization: `Bearer ${this.token}` },
				data,
				(res) => {
					if (res.res && res.msg === "ok") {
						this.getReplies();
					}
					this.showNotification("");
				}
			);
		},
		class_rating_submit() {
			const data = {
				class: this.item,
				answer: this.cls_rating,
			};

			Api.post_header(
				"api/class_rating_do",
				{ Authorization: `Bearer ${this.token}` },
				data,
				(res) => {
					if (res.res && res.msg === "ok") {
						this.cls_rating = "";
						this.$store.dispatch("handleSetUserData", this.token);
						alert("評分已送出");
					} else if (res.responseJSON.msg === "輸入參數錯誤") {
						alert("請勾選分數");
					}
				}
			);
		},
		play() {
			const video = $("video")[0];

			if (this.isPlay) {
				video.pause();
			} else {
				video.play();
			}
		},
		loadBoard() {
			if (this.partial + 10 < this.board.length) {
				this.partial += 10;
			} else {
				this.partial = this.board.length;
			}
		},
		showNotification(val) {
			this.beforeDelete = !this.beforeDelete;
			this.sn = val;
		},
	},

	created() {
		this.getReplies();
		this.$store.commit("navLeftSwitch", "show");
	},

	mounted() {
		feather.replace();
		this.$refs.class_video.addEventListener("playing", () => {
			this.isPlay = true;
		});
		this.$refs.class_video.addEventListener("pause", () => {
			this.isPlay = false;
		});
	},

	watch: {
		item(nv, ov) {
			this.getReplies();
			this.msg = "";
			this.name = "";
			this.isAnonymous = false;
			this.cls_rating = "";
			this.isPlay = false;
			this.partial = 10;
			this.isPosting = false;
			this.sn = "";
			this.beforeDelete = false;
		},
	},
};
</script>

<style lang="scss" scoped>
video {
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
}

.form-control {
	border: none;
	border-radius: 0;
}

textarea:focus,
input:focus {
	outline: none;
	box-shadow: none;
}

textarea,
input {
	font-size: 15px;
}

.text-btn {
	cursor: pointer;
	user-select: none;
}

.card-header.border-bottom {
	svg {
		display: inline-block;
		fill: var(--falcon-blue);
		stroke: var(--falcon-blue);
	}
}

.modal {
	background-color: rgba(#111, 0.7);
	transition: opacity 0.2s 0.5s linear;
	.modal-content {
		max-width: 85vw;
	}
}

.loading {
	cursor: pointer;
	user-select: none;
}
</style>
